var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-view"},[_c('HeaderHomeComp',{on:{"toggleMenu":_vm.toggleMenu}}),_c('QuienesSomosHomeComp'),_c('ResultadosHomeComp'),_c('CompromisoHomeComp'),_c('OrganigramaComp'),_c('IntegrantesHomeComp'),_c('NoticiasHomeComp'),_c('ContactoHomeComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }